<template>

  <div class="main">
    <GoBack></GoBack>

    <!-- Note that 'ref' is important here (value can be anything). read the description about `ref` below. -->
    <vue-croppie
      ref=croppieRef
      :enableOrientation="true"
      :enableResize="false"
      :viewport="{ width: 350, height: 350, type: 'square' }"
      @result="result">
    </vue-croppie>

    <p class="note">Crop your image above, then submit below.</p>

    <button @click="crop()" class="button-capture">
      <img src="../assets/jeep-capture.svg">
    </button>

    <!-- the result -->
    <img v-bind:src="cropped">
  </div>

</template>

<script>
import GoBack from '@/components/GoBack'

export default {
  name: 'camera2',
  components: {
    GoBack
  },
  data () {
    return {
      url: this.$store.state.payload.image,
      cropped: null,
      options: {
        format: 'jpeg',
        circle: false,
        size: 'original'
      }
    }
  },
  mounted () {
    // eslint-disable-next-line
    let orientation = 0
    this.$store.state.isLoading = false
    //
    this.$refs.croppieRef.bind({url: this.url})
  },
  methods: {
    goBack () {
      this.$store.commit('updatePayload', null)
      this.$router.push({ path: '/home' })
    },
    crop () {
      this.$store.state.isLoading = true
      // console.log('crop Refs', this.$refs.croppieRef.get())
      this.$refs.croppieRef.result(this.options, (output) => {
        console.log('inside result', output)
        this.cropped = output
        this.$store.commit('updatePayload', this.cropped)
        this.$router.push({ path: 'grill' })
      })
    },
    result (output) {
      console.log('result: ', this.cropped)
      this.cropped = output
    },
    rotate (rotationAngle) {
      // Rotates the image if needed
      this.$refs.croppieRef.rotate(rotationAngle)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
  .main {
    position: relative;
    padding-bottom: 30px;
    text-align: center;
  }

  .note {
    margin: 0;
    font-weight: 600;
    line-height: 46px;
    color: $color-1;
  }

  .button-capture {
    margin: 20px auto 0;
    cursor: pointer;

    img {
      width: 50px;
      height: 50px;
    }
  }
</style>
